import { jsx as _jsx } from "react/jsx-runtime";
const SurveyInvitationWrapper = ({ ariaLabel, children }) => (_jsx("aside", { "aria-label": ariaLabel, children: children }));
export default SurveyInvitationWrapper;
